import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Http, HttpModule, Headers, RequestOptions } from '@angular/http';
import firebase from '@firebase/app';
import '@firebase/auth';
import '@firebase/firestore';
import { UserService } from '../../services/user.service';
declare var fbq: any;

@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
  styleUrls: [
    "../../assets/vendor/bootstrap/bootstrap.css",
    "../../assets/vendor/bootstrap-select/dist/css/bootstrap-select.css",
    "../../assets/vendor/bootstrap-mega-menu/css/menu.css",
    "../../assets/fonts/font-awesome/css/fontawesome-all.min.css",
    "../../assets/vendor/WOW-master/css/libs/animate.css",
    "../../assets/vendor/hover.css",
    "../../assets/fonts/icon/font/flaticon.css",
    "../../assets/vendor/fancybox/dist/jquery.fancybox.min.css",
    "../../assets/vendor/jquery-ui/jquery-ui.min.css",
    "../../assets/css/material-kit.css",
    "../../assets/css/style-app.css",
  ]
})
export class LoginPage {

  db;
  user = {
    name: '',
    email: '',
    password: '',
  };
  authUser: any;
  lastAction = 'login';
  action = 'login';
  error = '';
  onVerifyRoute = false;
  emailSent = false;
  isVerifiedNow = false;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    public userService: UserService,
    public http: Http
  ) {
    this.db = firebase.firestore();
    if (this.router.url.includes('signup')) {
      this.action = 'create';
      this.lastAction = 'create';
    };
    this.route.params.subscribe(params => {
      if (params['verify']) {
        this.updateAction('verify');
        this.onVerifyRoute = true;
      }
    });

    if (this.getParameterByName('oobCode')) {
      this.isVerifiedNow = true;
    }
  }

  getParameterByName(name, url?) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  async userLoaded(user) {
    this.authUser = user;
    if (user && user.emailVerified && this.onVerifyRoute) {
      fbq('trackSingle', '205991469998512', 'Verified');
      this.goTo('complete');
    }
  }

  create(name, email, password) {
    firebase.auth()
    .createUserWithEmailAndPassword(email, password)
    .then((data) => {
      this.authUser = data;
      data.sendEmailVerification();

      // const headers = new Headers();
      // headers.append('Access-Control-Allow-Origin', '*');
      // headers.append('Access-Control-Allow-Credentials', 'true');

      // const options = new RequestOptions({headers: headers});

      // let subscribed = this.http.post('https://us-central1-bitl-it-analytics.cloudfunctions.net/getProfileViewAnalytics', {
      //       "email_address": email,
      //       "status": "subscribed",
      //       "merge_fields": {
      //           "FNAME": name,
      //           "LNAME": ""
      //       }
      //   }, options).subscribe(async (res: any) => {

      //     subscribed.unsubscribe();
      // });
      this.userService.saveUserSettings(true, { stripePlan: '' }, data.uid);
      this.userService.setProfile(data.uid, {
        $id: data.uid,
        name: name,
        email: email,
      }).then(() => {
        fbq('trackSingle', '205991469998512', 'Sign Up');
        if (this.onVerifyRoute) {
          this.reload();
        } else {
          this.goTo('verify');
        }
      });
    })
    .catch((error) => {
      this.updateError('create');
    });
  }

  login(email, password) {
    this.userService.login(email, password).then((data) => {
      this.goTo('links');
    }).catch((error) => {
      this.updateError('login');
    });
  }

  continue() {
    this.goTo('links');
  }

  resendConfirmEmail() {
    this.authUser.sendEmailVerification();
    this.emailSent = true;
    setTimeout(() => {this.emailSent = false}, 3000)
  }

  forgotPass() {
    this.updateAction('forgotPassword');
  }

  resetPassword(email) {
    this.userService.sendPasswordReset(email).then((data) => {
      this.updateAction('forgotPasswordSent');
      setTimeout(() => { this.updateAction('login'); }, 3000);
    }).catch((error) => {
      this.updateError('resetPassword');
    });
  }

  updateError(error) {
    this.error = error;
    setTimeout(() => { this.error = ''; }, 3000)
  }

  updateAction(action) {
    this.lastAction = this.action;
    this.action = action;
  }

  goToLastAction() {
    this.action = this.lastAction;
  }

  reload() {
    location.reload();
  }

  logout() {
    firebase.auth().signOut();
    this.goTo('login');
  }

  goTo(page) {
    switch(page) {
      case 'links':
        this.router.navigate(['/links']);
        break;
      case 'login':
        this.router.navigate(['/login']);
        break;
      case 'verify':
        this.router.navigate(['/signup/verify'])
        break;
      case 'complete':
        this.router.navigate(['/signup/complete'])
        break;
      case 'contact':
        // window.location.href = 'contact';
        break;
      default:
        break;
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts